'use client';

import React from 'react';
import FAQComponent from '@/components/frequently-asked-questions/FAQComponent';

interface PageContentProps {
  locale: string;
}

export default function PageContent({ locale }: PageContentProps) {
  return <FAQComponent locale={locale} />;
}
